import { render, staticRenderFns } from "./KeyIndicator.vue?vue&type=template&id=78b596e2"
import script from "./KeyIndicator.vue?vue&type=script&lang=js"
export * from "./KeyIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports